import i18n from '@/i18n'

export const baseRouteName = (routeName) =>
  routeName.includes(':') ? routeName.substring(0, routeName.indexOf(':')) : routeName

export const localizedRouteName = (targetRouteName) =>
  i18n.global.locale.value !== i18n.global.fallbackLocale.value
    ? `${targetRouteName}:en`
    : targetRouteName
